export const translations = {
  ru: {
    'service': 'нет услуг | 1 услуга | {n} услуги | {n} услуг',
    'Log in': 'Войти',
    'Log out': 'Выйти',
    'Login': 'Логин',
    'Password': 'Пароль',
    'Registration': 'Регистрация',
    'Enter': 'Вход',
    'Name': 'Имя',
    'First name': 'Имя',
    'Enter your password': 'Введите ваш пароль',
    'Repeat your password': 'Повторите ваш пароль',
    'Last name': 'Фамилия',
    'Middle name': 'Отчество',
    'Contact name': 'Имя контактного лица',
    'Email': 'Email',
    'Sign Up': 'Зарегистрироваться',
    'Personal invoice': 'Баланс лицевого счета',
    'Statistics': 'Статистика',
    'Edit profile': 'Редактировать профиль',
    'Payment form': 'Форма оплаты',
    'Order form': 'Форма заказа',
    'Buy': 'Купить',
    'Loading...': 'Загрузка...',
    'Active subscriptions': 'Активные подписки',
    'The email field is required': 'Обязательно для заполнения',
    'The firstname field is required': 'Обязательно для заполнения',
    'The email field must be a valid email': 'Е-mail адрес задан неверно',
    'The password field is required': 'Обязательно для заполнения',
    'The repassword field is required': 'Обязательно для заполнения',
    'The login field is required': 'Обязательно для заполнения',
    'The phone field is required': 'Обязательно для заполнения',
    'The agree field is required': 'Обязательно для заполнения',
    'The lastname field is required': 'Обязательно для заполнения',
    'The middlename field is required': 'Обязательно для заполнения',
    'The organization field is required': 'Обязательно для заполнения',
    'The full_search field is required': 'Введите логин или Email',
    'The dayOfMonth field is required': 'Обязательно для заполнения',
    'The period field is required': 'Обязательно для заполнения',
    'rub': '₽',
    'You are agree?': 'Вы согласны?',
    'Phone': 'Телефон',
    'Balance': 'Баланс',
    'Save': 'Сохранить',
    'Profile': 'Профиль',
    'Products': 'Продукты',
    'Payment': 'Платеж',
    'Services': 'Услуги',
    'Count of services': 'Количество услуг',
    'Sum': 'Сумма',
    'Submit': 'Отправить',
    'Sending': 'Отправка',
    'Home': 'Главная',
    'Title': 'Название',
    'Confirm code': 'Код подтверждения',
    'Enter confirmation code': 'Введите код подтверждения',
    'Confirm': 'Подтвердить',
    'Contact person': 'Контактное лицо',
    'Company name': 'Название организации',
    'Physical person': 'Физическое лицо',
    'Legal person': 'Юридическое лицо',
    'Send code by': 'Отправить код по',
    'Сontact last name': 'Фамилия контактного лица',
    'We sent you the code to the mail': 'Мы отправили код вам на почту',
    'SubscribeName': 'Название',
    'Date from': 'Дата с',
    'From date': 'С даты',
    'Date to': 'Дата до',
    'No active subscriptions': 'Нет активных подписок',
    'Invoice': 'Счёт',
    'Number P/I:': 'Номер договора',
    'Subscriptions': 'Подписки',
    'Cost': 'Стоимость',
    'Edit': 'Изменить',
    'Delete': 'Удалить',
    'Date': 'Дата',
    'Cancel': 'Отмена',
    'Close': 'Закрыть',
    'Add subscription': 'Добавить подписку',
    'New subscription': 'Новая подписка',
    'Change subscription': 'Изменить подписку',
    'Agreement': 'Договор',
    'Pay': 'Оплатить',
    'No payments': 'Нет платежей',
    'No statistics': 'Нет статистики',
    'Payments history': 'История платежей',
    'Product': 'Продукт',
    'Activate': 'Активировать',
    'Update': 'Обновить',
    'Product constructor': 'Конструктор продуктов',
    'No invoices': 'Нет счетов',
    'Documents': 'Документы',
    'Download': 'Скачать',
    'Add an employee': 'Добавить сотрудника',
    'Position': 'Должность',
    'Add': 'Добавить',
    'Incorrect code': 'Неверный код',
    'Security': 'Безопасность',
    'The confirmed-password confirmation does not match.': 'Не совпадает с введенным паролем',
    'Contacts': 'Контакты',
    'Company details': 'Реквизиты компании',
    'INN': 'ИНН',
    'KPP': 'КПП',
    'OGRN': 'ОГРН',
    'OGRNIP': 'ОГРНИП',
    'OKVED': 'ОКВЭД',
    'OKPO': 'ОКПО',
    'OKATO': 'ОКАТО',
    'Full bank name': 'Полное название банка',
    'Checking account': 'Расчетный счет',
    'Correspondent account': 'Корреспондентский счёт',
    'BIK': 'БИК',
    'The inn field must be numeric and exactly contain 12 digits': 'ИНН должен состоять из 12 цифр',
    'The inn field must be numeric and exactly contain 10 digits': 'ИНН должен состоять из 10 цифр',
    'The kpp field must be numeric and exactly contain 9 digits': 'КПП должен состоять из 9 цифр',
    'The ogrn field must be numeric and exactly contain 13 digits': 'ОГРН должен состоять из 13 цифр',
    'The ogrnip field must be numeric and exactly contain 15 digits': 'ОГРНИП должен состоять из 15 цифр',
    'The okpo field may only contain numeric characters': 'ОКПО должен состоять из цифр',
    'The okato field must be numeric and exactly contain 11 digits': 'ОКАТО должен состоять из 11 цифр',
    'The settl field must be numeric and exactly contain 20 digits': 'Расчетный счет должен состоять из 20 цифр',
    'The corr field must be numeric and exactly contain 20 digits': 'Корреспонденткий счет должен состоять из 20 цифр',
    'The bik field must be numeric and exactly contain 9 digits': 'БИК должен состоять из 9 цифр',
    'Subscription info': 'Информация о подписке',
    'More': 'Подробнее',
    'Please input the phone': 'Введите номер телефона',
    'Please input E-mail': 'Введите E-mail',
    'Please input first name': 'Введите имя',
    'Please input surname': 'Введите фамилию',
    'Please input organization name': 'Введите название организации',
    'Please accept terms and conditions': 'Примите соглашение',
    'I agree': 'Я принимаю',
    'Phones': 'Телефоны',
    'Message sent': 'Сообщение отправлено',
    'An error occurred while sending your message. Please try later.': 'Произошла ошибка при отправке сообщения. Попробуйте позже.',
    'An error occurred while activating subscription. Please try later.': 'Произошла ошибка при подключении подписки. Попробуйте позже.',
    'Go home': 'Домой',
    'Lost?': 'Заблудились?',
    'It seems that page not found.': 'Кажется такой страницы не сушествует.',
    'Registration confirmed!': 'Регистрация подтверждена!',
    'Now you can': 'Теперь вы можете',
    'sign in': 'войти',
    'to your customer portal': 'в личный кабинет',
    'Invalid activation code': 'Неверный код активации',
    'Details': 'Подробнее',
    'To cancel': 'Отменить',
    'Do you really want to activate the subscription?': 'Вы действительно хотите активировать подписку?',
    'Do you really want to change the subscription?': 'Вы действительно хотите изменить подписку?',
    'Do you really want to delete the subscription?': 'Вы действительно хотите удалить подписку?',
    'Do you really want to close the subscription?': 'Вы действительно хотите завершить подписку?',
    'Payment system': 'Платёжная система',
    'Create': 'Подключить',
    'Subscription activated': 'Подписка активирована',
    'Subscription changed': 'Подписка изменена',
    'Subscription cancelled': 'Подписка отменена',
    'Subscription stopped': 'Подписка остановлена',
    'Enter your E-Mail to receive an digital receipt': 'Укажите E-Mail для получения электронного чека',
    'Refill balance': 'Пополнить баланс',
    'For the last month': 'За последний месяц',
    'Employees': 'Сотрудники',
    'Edit employee': 'Изменить сотрудника',
    'Add employee': 'Добавить сотрудника',
    'Receive notification': 'Получать уведомления',
    'Receive invoices': 'Получать счета',
    'Do you really want to delete employee?': 'Вы действительно хотите удалить сотрудника?',
    'Employee created': 'Сотрудник добавлен',
    'Employee updated': 'Сотрудник обновлён',
    'Employee deleted': 'Сотрудник удалён',
    'An error occurred while creating employee. Please try later.': 'Произошла ошибка при создании сотрудника. Попробуйте позже.',
    'An error occurred while updating employee. Please try later.': 'Произошла ошибка при обновлении сотрудника. Попробуйте позже.',
    'Profile updated': 'Профиль обновлён',
    'Password updated': 'Пароль обновлён',
    'Notifications saved': 'Уведомления сохранены',
    'for': 'за',
    'Choose product': 'Выберите продукт',
    'Choose agreement': 'Выберите договор',
    'Choose period': 'Выберите период',
    'm': 'м',
    'bit': 'бит',
    'byte': 'байт',
    'kbyte': 'кбайт',
    'mbyte': 'мбайт',
    's': 'с',
    'min': 'мин',
    'h': 'ч',
    'd': 'сут;дн',
    // 'week': 'нед',
    'decade': 'дек',
    'quarter': 'кварт',
    'hyear': 'полгода',
    'a': 'год',
    'unit': 'ед',
    'pc': 'шт',
    'gbyte': 'гбайт',
    'Subscription': 'Подписка',
    'Payments': 'Платежи',
    'January': 'Января',
    'February': 'Февраля',
    'March': 'Марта',
    'April': 'Апреля',
    'May': 'Мая',
    'June': 'Июня',
    'July': 'Июля',
    'August': 'Августа',
    'September': 'Сентября',
    'October': 'Октября',
    'November': 'Ноября',
    'December': 'Декабря',
    'Theme': 'Тема',
    'Message': 'Сообщение',
    'Send': 'Отправить',
    'Close subscription': 'Закрыть подписку',
    'Personal information': 'Персональные данные',
    'Contact details': 'Контактные данные',
    'Change password': 'Сменить пароль',
    'Current password': 'Текущий пароль',
    'New password': 'Новый пароль',
    'New password again': 'Новый пароль еще раз',
    'The confirmedPassword field is required': 'Подтвердите новый пароль',
    'The confirmedPassword confirmation does not match': 'Не совпадает с введенным паролем',
    'Notifications': 'Уведомления',
    'SMS': 'СМС',
    'once': 'разово',
    'mo': 'мес',
    'Write-off': 'Списание',
    'Refill': 'Пополнение',
    'Since': 'С',
    'No operations': 'Операции отсутствуют',
    'Total': 'Всего',
    'No subscriptions': 'Нет подписок',
    'Send us a message': 'Отправьте нам сообщение',
    'Bank details': 'Банковская информация',
    'Sole proprietor': 'Индивидуальный предприниматель',
    'Writeoff': 'Списание',
    'Adjustment': 'Корректировка',
    'Processing': 'Обрабатывается',
    'Will start on': 'Станет активна',
    'Till': 'До',
    'Detailed information': 'Подробная информация',
    'Cancel subscription': 'Завершить подписку',
    'Delete subscription': 'Удалить подписку',
    'Yes': 'Да',
    'No': 'Нет',
    'Terminate': 'Завершить',
    'Subscription has been blocked by operator': 'Подписка заблокирована оператором',
    'Not enough funds for subscription': 'Не хватает средств на оплату подписки',
    'Links': 'Ссылки',
    'Addresses': 'Адреса',
    'Active': 'Активные',
    'Completed': 'Завершенные',
    'Today': 'Сегодня',
    'Yesterday': 'Вчера',
    'Subscription will be recreated after changing options': 'При изменении опций произойдет переподключение подписки',
    'Customer portal': 'Личный кабинет',
    'Token for password reset not found or already used': 'Токен не найден или устарел',
    'Notify if balance less than': 'Баланс опустился ниже',
    'Monthly balance state': 'Состояние баланса (ежемесячно)',
    'Payment received': 'Поступление и отмена платежа',
    'Send invoices via email': 'Разрешить отправку документов на email',
    'Send notification about blocking user subscription': 'Блокировка подписки',
    'Send notification about unblocking user subscription': 'Возобновление подписки',
    'A reminder that promised payment expires in 24 hours': 'Окончание срока обещанного платежа',
    'Send notification about due date and overdue event': 'Напоминание об оплате счёта',
    'Provider': 'Провайдер',
    'Period': 'Период',
    'Status': 'Статус',
    'Last payment': 'Последний платёж',
    'Do you really want to cancel the auto payment?': 'Вы действительно хотите отменить автоплатёж?',
    'Charge period in months': 'Период списаний в месяцах',
    'The dayOfMonth field must be 1 or more.': 'Значение должно быть больше 1',
    'The period field must be 1 or more.': 'Значение должно быть больше 1',
    'The dayOfMonth field must be 31 or less.': 'Значение должно быть меньше либо равно 31',
    'Create auto payment': 'Создать автоплатёж',
    'Day of the month': 'Число месяца',
    'You don\'t have any active auto payments yet': 'У вас пока нет активных автоплатежей',
    'The sum field is required.': 'Обязательно для заполнения',
    'Autopayment': 'Автоплатёж',
    'Value of sum must be greater than zero.': 'Сумма должна быть больше 0',
    'The autopaymentSum field is required.': 'Обязательно для заполнения',
    'Value of autopaymentSum must be greater than zero.': 'Сумма должна быть больше 0',
    'Autopayment sum': 'Сумма автоплатежа',
    'Recommended payment': 'Рекомендованный платёж',
    'Amount of subscriptions': 'Сумма подписок',
    'Write-off period': 'Период списаний',
    'Receive notifications': 'Получать уведомления',
    'Changes planned from {date}': 'Эти изменения запланированы с {date}',
    'Remove scheduled version': 'Удалить запланированную версию',
    'Open scheduled version': 'Открыть запланированную версию',
    'Scheduled subscription version': 'Запланированная версия подписки',
    'Are you sure you want to cancel your scheduled subscription?': 'Вы действительно хотите отменить запланированную версию подписки?',
    'Will start from {date}': 'Начнёт действовать {date}',
    'day': '— | 1 день | {n} дня | {n} дней',
    'week': '— | 1 неделя | {n} недели | {n} недель',
    'month': '— | 1 месяц | {n} месяца | {n} месяцев',
    'year': '— | 1 год | {n} года | {n} лет',
    'Services are not available': 'Нет доступных услуг',
    'Offer contract': 'Договор оферты',
    'Send notification about subscriptions changes': 'Изменение подписки'
  },
  az: {
    'service': 'Xidmət yoxdur | 1 xidmət | {n} xidmət | {n} xidmət',
    'month': 'ay yox | 1 ay | {n} ay | {n} ay',
    'Log in': 'Daxil ol',
    'Log out': 'Çıxış',
    'Login': 'İstifadəçi adı',
    'Password': 'Şifrə',
    'Registration': 'Qeydiyyat',
    'Enter': 'Giriş',
    'Name': 'Ad',
    'First name': 'Ad',
    'Enter your password': 'Şifrənizi daxil edin',
    'Repeat your password': 'Şifrənizi təstiqləyin',
    'Last name': 'Soyad',
    'Middle name': 'Ata adı',
    'Contact name': 'Əlaqəli şəxsin adı',
    'Email': 'E-poçt',
    'Sign Up': 'Qeydiyyatdan keçmək',
    'Personal invoice': 'Hesabın balansı',
    'Statistics': 'Statistika',
    'Active subscribe': 'Aktiv abunə',
    'Active': 'Aktiv',
    'Completed': 'Tamamlandı',
    'Edit profile': 'Profili redaktə etmək',
    'Payment form': 'Ödəniş forması',
    'Order form': 'Sifariş forması',
    'Buy': 'Almaq',
    'Loading...': 'Yüklənir...',
    'Active subscriptions': 'Aktiv abunələr',
    'The email field is required.': 'Mütləq doldurulmalıdır',
    'The email field must be a valid email.': 'Е-poçt ünvanı səhv daxil edilib',
    'The password field is required.': 'Mütləq doldurulmalıdır',
    'The repassword field is required.': 'Mütləq doldurulmalıdır',
    'The login field is required.': 'Mütləq doldurulmalıdır',
    'The phone field is required.': 'Mütləq doldurulmalıdır',
    'The agree field is required.': 'Mütləq doldurulmalıdır',
    'The firstname field is required': 'Mütləq doldurulmalıdır',
    'The lastname field is required': 'Mütləq doldurulmalıdır',
    'The middlename field is required': 'Mütləq doldurulmalıdır',
    'The organization field is required': 'Mütləq doldurulmalıdır',
    'The dayOfMonth field is required.': 'Mütləq doldurulmalıdır',
    'The period field is required.': 'Mütləq doldurulmalıdır',
    'The sum field is required.': 'Mütləq doldurulmalıdır',
    'The firstname field is required.': 'Mütləq doldurulmalıdır',
    'man': '₽',
    'You are agree?': 'Razısınız?',
    'Phone': 'Telefon',
    'Balance': 'Balans',
    'Save': 'Yadda saxlamaq',
    'Profile': 'Profil',
    'Products': 'Məhsullar',
    'Payment': 'Ödəniş',
    'Services': 'Xidmətlər',
    'Count of services': 'Xidmətlərin sayı',
    'Sum': 'Məbləğ',
    'Submit': 'Göndərmək',
    'Sending': 'Göndərilir',
    'Home': 'Əsas səhifə',
    'Title': 'Başlıq',
    'Confirm code': 'Təstiq kodu',
    'Enter confirmation code': 'Təsdiq kodunu daxil edin',
    'Confirm': 'Təsdiq edin',
    'Contact person': 'Əlaqəli şəxs',
    'Company name': 'Təşkilatın adı',
    'Physical person': 'Fiziki şəxs',
    'Legal person': 'Hüquqi şəxs',
    'Send code by': 'Kodu göndərmək',
    'Сontact last name': 'Əlaqəli şəxsin soyadı',
    'We sent you the code to the mail': 'Kod poçt ünvanınıza göndərildi',
    'SubscribeName': 'Abunəçinin adı',
    'Date from': 'Tarixdən',
    'From date': 'Tarixdən',
    'Date to': 'Tarixə qədər',
    'No active subscriptions': 'Aktiv abunə yoxdur',
    'Invoice': 'Hesab-faktura',
    'Number P/I:': 'Müqavilə nömrəsi',
    'Subscriptions': 'Abunələr',
    'Cost': 'Qiymət',
    'Edit': 'Dəyişmək',
    'Delete': 'Silmək',
    'Date': 'Tarix',
    'Cancel': 'İmtina',
    'Close': 'Bağlamaq',
    'Add subscription': 'Abunəçi əlavə etmək',
    'New subscription': 'Yeni abunə',
    'Change subscription': 'Abunəçi dəyişmək',
    'Agreement': 'Müqavilə',
    'Pay': 'Ödəniş etmək',
    'No payments': 'Ödəniş yoxdur',
    'No statistics': 'Statistika yoxdur',
    'Payments history': 'Ödəniş tarixçəsi',
    'Product': 'Məhsul',
    'Activate': 'Aktivləşdirmək',
    'Update': 'Yeniləmək',
    'Product constructor': 'Məhsulların konstruktoru',
    'No invoices': 'Hesab-faktura yoxdur',
    'Documents': 'Sənədlər',
    'Download': 'Yükləmək',
    'Add an employee': 'Əməkdaş əlavə etmək',
    'Position': 'Vəzifə',
    'Add': 'Əlavə etmək',
    'Incorrect code': 'Yalnış kod',
    'Security': 'Təhlükəsizlik',
    'The confirmed-password confirmation does not match.': 'Daxil edilmiş şifrə ilə uyğun gəlmir',
    'Contacts': 'Əlaqə',
    'Company details': 'Şirkətin rekvizitləri',
    'INN': 'VÖEN',
    'KPP': 'QAS',
    'OGRN': 'ƏDQN',
    'OGRNIP': 'FSƏDQN',
    'OKVED': 'XTFƏK',
    'OKPO': 'MTÜT',
    'OKATO': 'İƏTÜT',
    'Full bank name': 'Bankın tam adı',
    'Checking account': 'Hesablaşma hesabı',
    'Correspondent account': 'Müxbir hesab',
    'BIK': 'BİK',
    'The inn field must be numeric and exactly contain 12 digits': 'VÖEN 12 rəqəmdən ibarət olmalıdır',
    'The inn field must be numeric and exactly contain 10 digits': 'VÖEN 10 rəqəmdən ibarət olmalıdır',
    'The kpp field must be numeric and exactly contain 9 digits': 'QAS 9 rəqəmdən ibarət olmalıdır',
    'The ogrn field must be numeric and exactly contain 13 digits': 'ƏDQN 13 rəqəmdən ibarət olmalıdır',
    'The ogrnip field must be numeric and exactly contain 15 digits': 'FSƏDQN 15 rəqəmdən ibarət olmalıdır',
    'The okpo field may only contain numeric characters': 'MTÜT ƏDQN rəqəmdən ibarət olmalıdır',
    'The okato field must be numeric and exactly contain 11 digits': 'İƏTÜT 11 rəqəmdən ibarət olmalıdır',
    'The settl field must be numeric and exactly contain 20 digits': 'Hesablaşma hesabı 20 rəqəmdən ibarət olmalıdır',
    'The corr field must be numeric and exactly contain 20 digits': 'Müxbir hesab 20 rəqəmdən ibarət olmalıdır',
    'The bik field must be numeric and exactly contain 9 digits': 'BİK 9 rəqəmdən ibarət olmalıdır',
    'Subscription info': 'Abunə barədə məlumat',
    'More': 'Ətraflı',
    'Please input the phone': 'Telefon nömrəsini daxil edin',
    'Please input E-mail': 'E-poçt ünvanını daxil edin',
    'Choose product': 'Məhsulu seçin',
    'Choose agreement': 'Müqaviləni seçin',
    'm': 'm',
    'bit': 'bit',
    'byte': 'bayt',
    'kbyte': 'kbayt',
    'mbyte': 'mbayt',
    's': 's',
    'min': 'dəq',
    'h': 'saat',
    'd': 'gün',
    'week': 'həftə',
    'decade': 'dekada',
    'quarter': 'rüb',
    'hyear': 'yarımil',
    'a': 'il',
    'unit': 'vahid',
    'pc': 'əd',
    'gbyte': 'gbayt',
    'Subscription': 'Abunə',
    'Payments': 'Ödənişlər',
    'January': 'Yanvar',
    'February': 'Fevral',
    'March': 'Mart',
    'April': 'Aprel',
    'May': 'May',
    'June': 'İyun',
    'July': 'İyul',
    'August': 'Avqust',
    'September': 'Sentyabr',
    'October': 'Oktyabr',
    'November': 'Noyabr',
    'December': 'Dekabr',
    'Theme': 'Mövzu',
    'Message': 'Mesaj',
    'Send': 'Göndərmək',
    'Close subscription': 'Abunəni bağlamaq',
    'Personal information': 'Fərdi məlumatlar',
    'Contact details': 'Əlaqə məlumatları',
    'Change password': 'Şifrəni dəyişmək',
    'Current password': 'Cari şifrə',
    'New password': 'Yeni şifrə',
    'New password again': 'Yeni şifrə təkrarən',
    'The confirmedPassword field is required': 'Yeni şifrəni təsdiqləyin',
    'The confirmedPassword confirmation does not match': 'Daxil edilmiş şifrə ilə uyğun gəlmir',
    'Notifications': 'Bildirişlər',
    'SMS': 'SMS',
    'once': 'birdəfəlik',
    'daily': 'gün',
    'mo': 'ay',
    'Write-off': 'Silinmə',
    'Refill': 'Artırma',
    'Since': ' ',
    'No operations': 'Əməliyyatlar yoxdur',
    'Total': 'Cəmi',
    'No subscriptions': 'Abunələr yoxdur',
    'Send us a message': 'Bizə mesaj göndərin',
    'Bank details': 'Bank məlumatları',
    'Sole proprietor': 'Fərdi sahibkar',
    'Writeoff': 'Silinmə',
    'Adjustment': 'Düzəliş etmək',
    'Processing': 'Emal edilir',
    'Will start on': 'Aktiv olacaq',
    'Till': 'Dək',
    'Detailed information': 'Ətraflı məlumat',
    'Cancel subscription': 'Abunəni ləğv etmək',
    'Delete subscription': 'Abunəni silmək',
    'Yes': 'Bəli',
    'No': 'Xeyr',
    'Terminate': 'Dayandırmaq',
    'Subscription has been blocked by operator': 'Abunə operator tərəfindən bloklanıb',
    'Not enough funds for subscription': 'Abunəçinin hesabında kifayət qədər vəsait yoxdur',
    'Please input first name': 'Adınızı daxil edin',
    'Please input surname': 'Soyadınızı daxil edin',
    'Please input organization name': 'Təşkilatın adını daxil edin',
    'Please accept terms and conditions': 'Razılaşmanı qəbul edin',
    'I agree': 'Mən qəbul edirəm',
    'Phones': 'Telefonlar',
    'Message sent': 'Mesaj göndərildi',
    'An error occurred while sending your message. Please try later.': 'Mesaj göndərilmə zamanı xəta baş verdi. Bir az sonra cəhd edin.',
    'An error occurred while activating subscription. Please try later.': 'Abunənin qoşulması zamanı xəta baş verdi. Bir az sora cəhd edin.',
    'Go home': 'Ana səhifə',
    'Lost?': 'Sizə necə köməklik göstərə bilərik?',
    'It seems that page not found.': 'Səhifə tapılmadı.',
    'Registration confirmed!': 'Qeydiyyat təstiqləndi!',
    'Now you can': 'Hal xazırda',
    'sign in': 'şəxsi',
    'to customer portal': 'kabinetinizə daxil ola bilərsiniz',
    'Invalid activation code': 'Səhv aktivləşdirmə kodu',
    'Details': 'Ətraflı',
    'To cancel': 'İmtina etmək',
    'Do you really want to activate the subscription?': 'Doğurdanmı abunəni aktivləşdirmək istəyirsiniz?',
    'Do you really want to change the subscription?': 'Doğurdanmı abunəni dəyişmək istəyirsiniz?',
    'Do you really want to delete the subscription?': 'Doğurdanmı abunəni silmək istəyirsiniz?',
    'Do you really want to close the subscription?': 'Doğurdanmı abunəni tamamlamaq istəyirsiniz?',
    'Payment system': 'Ödəniş sistemi',
    'Create': 'Qoşmaq',
    'Subscription activated': 'Abunəlik aktiv olundu',
    'Subscription changed': 'Abunəlik dəyişdirildi',
    'Subscription cancelled': 'Abunəlik ləğv edildi',
    'Subscription stopped': 'Abunəlik dayandırıldı',
    'Enter your E-Mail to receive an digital receipt': 'Elektron qəbzin alınması üçün E-poçt ünvanızı qeyd edin',
    'Refill balance': 'Balansı artırmaq',
    'For the last month': 'Sonuncu aya görə',
    'Employees': 'Əməkdaşlar',
    'Edit employee': 'Əməkdaşı dəyişmək',
    'Add employee': 'Əməkdaşı əlavə etmək',
    'Receive notification': 'Bildirişləri qəbul etmək',
    'Receive invoices': 'Hesab-fakturaları almaq',
    'Do you really want to delete employee?': 'Doğurdanmı əməkdaşı sistemdən silmək istəyirsiniz?',
    'Employee created': 'Əməkdaş əlavə edildi',
    'Employee updated': 'Əməkdaş yeniləndi',
    'Employee deleted': 'Əməkdaş silindi',
    'An error occurred while creating employee. Please try later.': 'Əməkdaşın yaradılması zamanı xəta baş verdi. Bir az sonra cəhd edin.',
    'An error occurred while updating employee. Please try later.': 'Əməkdaşın yenilinməsi zamanı xəta baş verdi. Bir az sonra cəhd edin.',
    'Profile updated': 'Profil yeniləndi',
    'Password updated': 'Şifrə yeniləndi',
    'Notifications saved': 'Bildirişlər yadda saxlanıldı',
    'for': 'görə',
    'Links': 'LİNKLƏR',
    'Addresses': 'Ünvanlar',
    'Today': 'Bu gün',
    'Yesterday': 'Dünən',
    'Subscription will be recreated after changing options': 'Seçimləri dəyişdirdiyiniz zaman abunəlik yenidən bağlanacaq',
    'Send invoices via email': 'E-poçt vasitəsilə faktura alın',
    'Payment received': 'Ödənişin daxil olması və ya ləğv edildiyi barədə bildiriş',
    'Monthly balance state': 'Vəsaitin qalığı haqqında aylıq hesabat',
    'Notify if balance less than': 'Balansın aşağı həddi keçdiyi barədə xəbərdarlıq',
    'Customer portal': 'Şəxsi sahə',
    'A reminder that promised payment expires in 24 hours': 'Söz verilən ödənişin bitməsi haqqında 24 saatlıq xatırlatma',
    'Send notification about blocking user subscription': 'Abunəliyin bloklandığı mesajı',
    'Send notification about unblocking user subscription': 'Abunəliyin kilidinin açıldığı barədə mesaj',
    'Provider': 'Provayder',
    'Period': 'Dövr',
    'Status': 'Vəziyyət',
    'Last payment': 'Son ödəniş',
    'Do you really want to cancel the auto payment?': 'Avtomatik ödənişi ləğv etmək istədiyinizə əminsiniz?',
    'Create auto payment': 'Avtomatik ödəniş yaradın',
    'Day of the month': 'Ayın günü',
    'You don\'t have any active auto payments yet': 'Hələ heç bir aktiv avtomatik ödənişiniz yoxdur',
    'Autopayment': 'Avtomatik ödəniş',
    'Autopayment sum': 'Avtomatik ödəniş məbləği',
    'Recommended payment': 'Tövsiyə olunan ödəniş',
    'Amount of subscriptions': 'Abunəliklərin miqdarı',
    'Write-off period': 'Silinmə müddəti',
    'Recieve notifications': 'Bildirişlər almaq',
    'Changes planned from {date}': '{date} tarixindən planlaşdırılan dəyişikliklər',
    'Send notification about due date and overdue event': 'Bill ödəniş xatırlatma',
    'Remove scheduled version': 'Planlaşdırılmış versiyanı silin',
    'Open scheduled version': 'Planlaşdırılmış versiyanı açın',
    'Scheduled subscription version': 'Planlaşdırılmış abunə versiyası',
    'Are you sure you want to cancel your scheduled subscription?': 'Planlaşdırılmış abunəliyinizi ləğv etmək istədiyinizə əminsiniz?',
    'Will start from {date}': '{date} tarixində fəaliyyətə başlayır',
    'Send notification about subscriptions changes': 'Abunəliyi dəyişdirin'
  }
}
